import { AxiosError } from "axios";

import {
  ActionTypes,
  IFetchInvoicesSuccessPayload,
  fetchInvoicePayload,
} from "./types";
import {
  FETCHING_INVOICES,
  FETCH_INVOICES_ERROR,
  FETCH_INVOICES_SUCCESS,
  FETCH_INVOICE_TRIGGER,
} from "./constants";

export const fetchInvoiceTrigger = (
  payload: fetchInvoicePayload,
): ActionTypes => {
  return {
    type: FETCH_INVOICE_TRIGGER,
    payload,
  };
};

export const fetchingInvoices = (payload: fetchInvoicePayload): ActionTypes => {
  return {
    type: FETCHING_INVOICES,
    payload,
  };
};

export const fetchInvoicesSuccess = (
  payload: IFetchInvoicesSuccessPayload,
): ActionTypes => {
  return {
    type: FETCH_INVOICES_SUCCESS,
    payload,
  };
};

export const fetchInvoicesError = (error: AxiosError): ActionTypes => {
  return {
    type: FETCH_INVOICES_ERROR,
    payload: error,
  };
};
